export const getDocumentTitle = (): string => {
  return document.title;
};
